import { createEntityStore } from "@/core/factory/store"
import { Job, JOB_ENTITY, createEmptyJob } from "./job.types"
import { noContext } from "@/core/utils/noContext"

export const createJobStore = () => {
  const store = createEntityStore<Job, null>(JOB_ENTITY, createEmptyJob, noContext)

  return {
    ...store,
    selectors: {
      ...store.selectors
    },
    thunks: {
      ...store.thunks
    }
  }
}

const jobStore = createJobStore()
export default jobStore
